export const FOOTER_PROPS_DEFAULT =
    {
        'items-per-page-options': [5, 10, 25, 50, -1]
    };
export const FOOTER_PROPS_5_10_ALL =
    {
        'items-per-page-options': [5, 10, -1]
    };
